import { ITheme } from '.'

// ====================== //
// ======= COLORS ======= //
// ====================== //
const black1 = '#1c1d22'
const black2 = '#000000'
const black3 = '#070707'
const black4 = '#424242'
const black5 = '#1f1e1e'

const yellow1 = '#070707'
const yellow2 = '#070707'

const white1 = '#ffffff'
const white2 = '#f9f9f9'
const white3 = '#eeeeee'
const white4 = 'fdfdfd'

const grey1 = '#cccccc'
const grey2 = '#757575'
const grey3 = '#f5f5f5'
const grey4 = '9e9e9e'

const green1 = '#00cd52'

const red1 = '#ff0000'

const blue1 = '#03395a'

// ====================== //
// ======= FONT-FAMILY ======= //
// ====================== //
const font1 = 'Roboto'
const font2 = 'Inter'

// ===================== //
// ======= THEME ======= //
// ===================== //
const Theme: ITheme = {
  pallete: {
    PRIMARY: black1,
    PRIMARY2: black2,
    PRIMARY3: black3,
    PRIMARY4: black4,
    PRIMARY5: black5,
    SECONDARY: white1,
    SECONDARY2: white2,
    SECONDARY3: white3,
    SECONDARY4: white4,
    TERTIARY: yellow1,
    TERTIARY2: yellow2,
    QUATERNARY: grey1,
    QUATERNARY2: grey2,
    QUATERNARY3: grey3,
    QUARTENARY4: grey4,
    QUINARY: green1,
    SENARY: red1,
    SEPTENARY: blue1,
  },
  icons: {
    PRIMARY:
      'brightness(0) saturate(100%) invert(88%) sepia(0%) saturate(4097%) hue-rotate(65deg) brightness(91%) contrast(98%)',
    SECONDARY:
      'brightness(0) saturate(100%) invert(70%) sepia(68%) saturate(822%) hue-rotate(355deg) brightness(103%) contrast(111%)',
    SECONDARY2:
      'brightness(0) saturate(100%) invert(81%) sepia(25%) saturate(3935%) hue-rotate(359deg) brightness(103%) contrast(103%)',
    TERTIARY:
      'brightness(0) saturate(100%) invert(100%) sepia(99%) saturate(2%) hue-rotate(37deg) brightness(105%) contrast(101%)',
    TERTIARY2:
      'brightness(0) saturate(100%) invert(21%) sepia(4%) saturate(13%) hue-rotate(337deg) brightness(105%) contrast(85%)',
    QUATERNARY:
      'brightness(0) saturate(100%) invert(67%) sepia(30%) saturate(4995%) hue-rotate(97deg) brightness(93%) contrast(101%)',
    QUINARY:
      'brightness(0) saturate(100%) invert(10%) sepia(63%) saturate(7082%) hue-rotate(358deg) brightness(133%) contrast(118%)',
    SENARY:
      'invert(12%) sepia(95%) saturate(5126%) hue-rotate(357deg) brightness(106%) contrast(115%)',
    SEPTENARY:
      'brightness(0) saturate(100%) invert(48%) sepia(82%) saturate(5461%) hue-rotate(160deg) brightness(98%) contrast(98%)',
  },
  fontFamily: {
    PRIMARY: font1,
    SECONDARY: font2,
  },
  sizes: {
    CARDS: {
      WIDTH: { PRIMARY: 135, SECONDARY: 42 },
      HEIGHT: { PRIMARY: 112, SECONDARY: 13 },
      FONT: { PRIMARY: 18, SECONDARY: 12, TERTIARY: 7.5 },
      IMAGE: { PRIMARY: 18 },
      MARGIN: { PRIMARY: 7.5, SECONDARY: 9.5 },
      PADDING: {
        PRIMARY: 44,
        SECONDARY: 24,
        TERTIARY: 18,
        QUATERNARY: 62,
        QUINARY: 1.5,
        SENARY: 4.5,
      },
      GAP: { PRIMARY: 7.5 },
      DISTANCE: { PRIMARY: 31.6, SECONDARY: 64 },
      BORDER: {},
    },
    BUTTONS: {
      WIDTH: {
        PRIMARY: 135,
        SECONDARY: 237,
        TERTIARY: 120,
        QUATERNARY: 230,
        QUINARY: 50,
        SENARY: 20,
        SEPTENARY: 10,
      },
      HEIGHT: {
        PRIMARY: 42,
        SECONDARY: 50,
        TERTIARY: 20,
        QUATERNARY: 10,
      },
      FONT: {
        PRIMARY: 10.5,
        SECONDARY: 14,
        TERTIARY: 20,
      },
      IMAGE: {
        PRIMARY: 18,
        SECONDARY: 12,
        TERTIARY: 24,
      },
      MARGIN: {
        PRIMARY: 6,
        SECONDARY: 24,
      },
      PADDING: { PRIMARY: 13 },
      GAP: { PRIMARY: 20, SECONDARY: 32, TERTIARY: 8 },
      DISTANCE: {},
      BORDER: {},
    },
    CONTAINERS: {
      WIDTH: { PRIMARY: 250 },
      HEIGHT: { PRIMARY: 308, SECONDARY: 18 },
      FONT: { PRIMARY: 15, SECONDARY: 12 },
      IMAGE: { PRIMARY: 157.5, SECONDARY: 31.6 },
      MARGIN: {
        PRIMARY: 48,
        SECONDARY: 24,
      },
      PADDING: {
        PRIMARY: 48,
      },
      GAP: {
        PRIMARY: 20,
      },
      DISTANCE: {},
      BORDER: {},
    },
    SEARCHBAR: {
      WIDTH: {
        PRIMARY: 422,
        SECONDARY: 315,
        TERTIARY: 135,
      },
      HEIGHT: {
        PRIMARY: 48,
        SECONDARY: 40,
      },
      FONT: {
        PRIMARY: 13,
        SECONDARY: 10.5,
      },
      IMAGE: {
        PRIMARY: 16,
      },
      MARGIN: {},
      PADDING: {
        PRIMARY: 8,
      },
      GAP: {
        PRIMARY: 10,
      },
      DISTANCE: {},
      BORDER: {},
    },
    SPAN: {
      WIDTH: { PRIMARY: 237 },
      HEIGHT: { PRIMARY: 15 },
      FONT: {
        PRIMARY: 10.5,
      },
      IMAGE: {},
      MARGIN: { PRIMARY: 12 },
      PADDING: {},
      GAP: {},
      DISTANCE: {},
      BORDER: {},
    },
    KANBAN: {
      WIDTH: {
        PRIMARY: 364,
        SECONDARY: 270,
        TERTIARY: 1400,
        QUATERNARY: 210,
        QUINARY: 190,
        SENARY: 150,
        SEPTENARY: 6,
      },
      HEIGHT: {
        PRIMARY: 618,
        SECONDARY: 26,
        TERTIARY: 142,
        QUATERNARY: 172,
        QUINARY: 32,
        SENARY: 14,
        SEPTENARY: 16,
      },
      FONT: { PRIMARY: 16, SECONDARY: 14, TERTIARY: 12, QUATERNARY: 10 },
      IMAGE: { PRIMARY: 24, SECONDARY: 16 },
      MARGIN: {
        PRIMARY: 5,
        SECONDARY: 15,
        TERTIARY: 20,
        QUATERNARY: 10,
        QUINARY: 8,
        SENARY: 10,
      },
      PADDING: { PRIMARY: 20, SECONDARY: 10, TERTIARY: 2, QUATERNARY: 6 },
      GAP: { PRIMARY: 5, SECONDARY: 8, TERTIARY: 6 },
      DISTANCE: {},
      BORDER: {},
    },
    BANNER: {
      WIDTH: { PRIMARY: 300 },
      HEIGHT: { PRIMARY: 120 },
      FONT: { PRIMARY: 14, SECONDARY: 12 },
      IMAGE: {},
      MARGIN: {},
      PADDING: {},
      GAP: {},
      DISTANCE: {},
      BORDER: {},
    },
    INPUTS: {
      WIDTH: { PRIMARY: 237, SECONDARY: 161 },
      HEIGHT: { PRIMARY: 20, SECONDARY: 48 },
      FONT: { PRIMARY: 14, SECONDARY: 12 },
      IMAGE: {},
      MARGIN: {},
      PADDING: {
        PRIMARY: 2,
        SECONDARY: 14,
        TERTIARY: 16,
        QUATERNARY: 5,
        QUINARY: 20,
      },
      GAP: {},
      DISTANCE: { PRIMARY: 11, SECONDARY: -11 },
      BORDER: {},
    },
    SELECTS: {
      WIDTH: { PRIMARY: 104, SECONDARY: 112, TERTIARY: 135, QUATERNARY: 237 },
      HEIGHT: { PRIMARY: 38, SECONDARY: 58 },
      FONT: { PRIMARY: 10.5, SECONDARY: 9 },
      IMAGE: {},
      MARGIN: { PRIMNARY: 1.5 },
      PADDING: {
        PRIMARY: 7.5,
        SECONDARY: 15,
        TERTIARY: 12,
        QUATERNARY: 22.5,
        QUINARY: 4,
      },
      GAP: {},
      DISTANCE: {},
      BORDER: {},
    },
  },
}

export default Theme
